import * as _ from "lodash"
import {ISearchRequest, PASearch} from "../PA.Core/PASearch";
import {
    IEntityPath,
    IHierarchyInfo,
    IHierarchyScope,
    IHierarchyUsageService
} from "../PA.MD.Core/PA.MD.IF.HierarchyUsage";


const vHierInfo_String_Fields = ['ENTITY_DIMENSION', 'HIERARCHY_ID', 'HIERARCHY_NAME', 'HIERARCHY_STATUS','RELATIONSHIP_TIME_POLICY','APPLICATION_AREAS']
const vHierInfo_Number_Fields = ['WB_HIERARCHY_ID', 'WB_MDSET_ID', 'TARGET_WB_ID']
const vHierInfo_Fields = [...vHierInfo_Number_Fields, ...vHierInfo_String_Fields]
const vHierPath_String_Fields = ['LEVEL_ID_SOURCE', 'ENTITY_ID_SOURCE', 'ENTITY_NAME_SOURCE', 'LEVEL_ID_TARGET', 'ENTITY_ID_TARGET', 'ENTITY_NAME_TARGET', 'DIRECTION']
const vHierPath_Number_Fields = ['LEVEL_DEPTH_SOURCE', 'LEVEL_DEPTH_TARGET', 'WB_ENTITY_ID_SOURCE', 'WB_ENTITY_ID_TARGET']
const vHierPathOnly_Fields = [...vHierPath_Number_Fields, ...vHierPath_String_Fields]
const vHierInfoPath_Fields = [...vHierInfo_Fields, ...vHierPathOnly_Fields]
const vHierSA_Number_Fields = ['WB_SALESAREA_ID', 'WB_SALESORG_ID', 'WB_COMPANY_ID']


const vWB_Hierarchy_EntityMap_SA = PASearch.createSimpleSchema(
    [...vHierInfo_String_Fields,
               ...vHierPath_String_Fields],
    [...vHierInfo_Number_Fields,
                 ...vHierPath_Number_Fields,
                 ...vHierSA_Number_Fields])

const vWB_Hierarchy_EntityMap = PASearch.createSimpleSchema(
    [...vHierInfo_String_Fields,
               ... vHierPath_String_Fields],
  [...vHierInfo_Number_Fields,
               ...vHierPath_Number_Fields])


export class HierarchyUsage
    implements IHierarchyUsageService
{
    async getHierarchies(scope: IHierarchyScope): Promise<IHierarchyInfo[]> {
        let rv: IHierarchyInfo[] = []

        let results = await this.getViewData(vHierInfo_Fields, 0, 0, scope)

        _.forEach(results, (row: any) => {
            rv.push({
                wbHierarchyId: row.WB_HIERARCHY_ID,
                HierarchyId: row.HIERARCHY_ID,
                HierarchyName: row.HIERARCHY_NAME,
                wbHierTargetId: row.TARGET_WB_ID,
                Status: row.HIERARCHY_STATUS,
                TimePolicy: row.RELATIONSHIP_TIME_POLICY,
                AppAreas: row.APPLICATION_AREAS
            })
        })

        return this.filterAppAreas(scope, rv)
    }

    async getSourceEntityPaths(wbEntityId_Source: number, scope: IHierarchyScope): Promise<IEntityPath[]> {
        return await this.getPaths(wbEntityId_Source, undefined, scope)
    }

    async getEntityPaths(wbEntityId_Source: number, wbEntityId_Target: number, scope: IHierarchyScope): Promise<IEntityPath[]> {
        return await this.getPaths(wbEntityId_Source, wbEntityId_Target, scope)
    }

    getPathHierarchies(arr: IEntityPath[]): IHierarchyInfo[] {
        let dct: {[wbId: number]: IHierarchyInfo} = {}

        let rv: IHierarchyInfo[] = []
        _.forEach(arr, (path) => {
            if(!(path.wbHierarchyId in dct)){

                let h: IHierarchyInfo = {
                    wbHierarchyId: path.wbHierarchyId,
                    HierarchyId: path.HierarchyId,
                    HierarchyName: path.HierarchyName,
                    wbHierTargetId: path.wbHierTargetId,
                    Status: path.Status,
                    TimePolicy: path.TimePolicy,
                    AppAreas: path.AppAreas,
                    Paths: []
                }
                dct[path.wbHierarchyId] = h
                rv.push(h)
            }

            let h = dct[path.wbHierarchyId]
            h.Paths.push(path)
        })


        return rv
    }

    private createNumberCnd(q: any, fieldName: string, value: any) {
        switch (true) {
            case _.isUndefined(value):
                return;
            case _.isArray(value):
                q[fieldName] = { inq: value };
                return;
            case _.isNumber(value):
                q[fieldName] = value;
                return;
        }
    }

    private createStringCnd(q: any, fieldName: string, value: any) {
        switch (true) {
            case _.isUndefined(value):
                return;
            case _.isArray(value):
                q[fieldName] = { inq: value };
                return;
            case _.isString(value):
                q[fieldName] = value;
                return;
        }
    }

    private async getPaths(wbEntityId_Source: number, wbEntityId_Target: number, scope: IHierarchyScope): Promise<IEntityPath[]> {
        let rv: IEntityPath[] = []

        let results = await this.getViewData(vHierInfoPath_Fields, wbEntityId_Source, wbEntityId_Target, scope)

        _.forEach(results, (row: any) => {
            rv.push({
                wbHierarchyId: row.WB_HIERARCHY_ID,
                HierarchyId: row.HIERARCHY_ID,
                HierarchyName: row.HIERARCHY_NAME,
                wbHierTargetId: row.TARGET_WB_ID,
                Status: row.HIERARCHY_STATUS,
                TimePolicy: row.RELATIONSHIP_TIME_POLICY,
                AppAreas: row.APPLICATION_AREAS,

                SourceLevelId: row.LEVEL_ID_SOURCE,
                SourceDepth: row.LEVEL_DEPTH_SOURCE,
                SourceWbEntityId: row.WB_ENTITY_ID_SOURCE,

                TargetLevelId: row.LEVEL_ID_TARGET,
                TargetDepth: row.LEVEL_DEPTH_TARGET,
                TargetWbEntityId: row.WB_ENTITY_ID_TARGET,

                Direction: row.DIRECTION
            })
        })

        return this.filterAppAreas(scope, rv)

    }
    private async getViewData(arrViewFields: string[],
                              wbEntityId_Source: number, wbEntityId_Target: number, scope: IHierarchyScope): Promise<any[]> {
        const self = this
        let opts = scope || {}
        let req: ISearchRequest = {
            model: 'vWB_Hierarchy_EntityMap_SA',
            distinct: arrViewFields,
            fields: vWB_Hierarchy_EntityMap_SA,
            where: {}
        }

        self.createNumberCnd(req.where, 'WB_MDSET_ID', opts.wbMDSetId)
        self.createNumberCnd(req.where, 'WB_COMPANY_ID', opts.wbCompanyId)
        self.createNumberCnd(req.where, 'WB_SALESORG_ID', opts.wbSalesOrgId)
        self.createNumberCnd(req.where, 'WB_SALESAREA_ID', opts.wbSalesAreaId)
        self.createStringCnd(req.where, 'ENTITY_DIMENSION', opts.entityDimension)
        self.createStringCnd(req.where, 'RELATIONSHIP_TIME_POLICY', opts.relationshipTimePolicy)

        if(wbEntityId_Source > 0)
            self.createNumberCnd(req.where, 'WB_ENTITY_ID_SOURCE', wbEntityId_Source)
        else if(opts.wbEntityIdSource > 0)
            self.createNumberCnd(req.where, 'WB_ENTITY_ID_SOURCE', opts.wbEntityIdSource)

        if(wbEntityId_Target > 0)
            self.createNumberCnd(req.where, 'WB_ENTITY_ID_TARGET', wbEntityId_Target)
        else if(opts.wbEntityIdTarget > 0)
            self.createNumberCnd(req.where, 'WB_ENTITY_ID_TARGET', opts.wbEntityIdTarget)

        return await PASearch.findByRequest(req)
    }

    private filterAppAreas<T extends IHierarchyInfo>(scope: IHierarchyScope, r: T[]): T[] {
        if(_.isEmpty(scope?.applicationArea))
            return r
        let arrAppAreas: string[] = []

        if(_.isString(scope.applicationArea))
            arrAppAreas = scope.applicationArea.split(",")
        else if(_.isArray(scope.applicationArea))
            arrAppAreas = scope.applicationArea
        else
            return r

        if(_.isEmpty(arrAppAreas))
            return r

        let rv: T[] = []
        _.forEach(r, (row) => {
            let dctApp = _.keyBy(row.AppAreas.split(","), (a) => a)
            if(_.isEmpty(dctApp))
                return
            for(let fApp of arrAppAreas){
                if(fApp in dctApp){
                    rv.push(row)
                    break
                }
            }
        })
        return rv
    }

    async getSrcEntityLevelId(sEntityDimension: string, wbNativeId: number,  wbEntityId: number): Promise<string> {
        // Use search service to retrieve data
        const req: ISearchRequest = {
            model: 'vWB_Hierarchy_EntityMap',
            distinct: ['LEVEL_ID_SOURCE','LEVEL_DEPTH_SOURCE'],
            fields: vWB_Hierarchy_EntityMap,
            where: {UNIQUE_IND_SOURCE: '1', DIRECTION: 'Flat',
                    ENTITY_DIMENSION: sEntityDimension, TARGET_WB_ID: wbNativeId, WB_ENTITY_ID_SOURCE: wbEntityId},
            order: ['LEVEL_DEPTH_SOURCE DESC']
        }

        let results = await PASearch.findByRequest(req)

        if(_.isEmpty(results))
            return ""
        const f = _.first(results)

        return f.LEVEL_ID_SOURCE
    }


}